import { request } from "../utils/request.js"

export const purchaseOrder_exportForManage = (pojo, args) => request({
    url: 'purchaseOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findPageForManage = (pojo, args) => request({
    url: 'purchaseOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findPageListForManage = (pojo, args) => request({
    url: 'purchaseOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'purchaseOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'purchaseOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findPageForSelect = (pojo, args) => request({
    url: 'purchaseOrder/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_findPageListForSelect = (pojo, args) => request({
    url: 'purchaseOrder/findPageListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const purchaseOrder_saveIntoDraft = (pojo, args) => request({
    url: 'purchaseOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'purchaseOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_update = (pojo, args) => request({
    url: 'purchaseOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_updateAndSubmit = (pojo, args) => request({
    url: 'purchaseOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_submitById = (id, args) => request({
    url: 'purchaseOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_deleteById = (id, args) => request({
    url: 'purchaseOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const purchaseOrder_approval = (pojo, args) => request({
    url: 'purchaseOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const purchaseOrder_findById = (id, args) => request({
    url: 'purchaseOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

// findByIdIn - 
export const purchaseOrder_findByIdIn = (param, args) => request({
	url: 'purchaseOrder/findByIdIn',
	method: 'POST',
	params: param,
    showFailMessage: true,
	...args
})

export const purchaseOrder_findVoById = (id, args) => request({
    url: 'purchaseOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const purchaseOrder_generatePrintPdf = (pojo, args) => request({
    url: 'purchaseOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/purchaseOrder.js